<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <v-btn
            color="#000"
            icon
            style="margin-left: -10px"
            @click="fecharDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <span class="headline ml-3">Parâmetros do Fornecedor</span>
        </v-card-title>

        <v-divider class="mb-6"></v-divider>

        <v-card-text class="mt-3">
          <v-switch
            v-if="multiplos_fornecedores_selecionados.length > 1"
            v-model="multiplos_fornecedores"
            inset
            label="Aplicar para todos os fornecedores selecionados?"
          />

          <v-divider v-if="multiplos_fornecedores_selecionados.length > 1" class="mb-5"/>

          <v-row>
            <v-col cols="5" class="pb-0 mb-n3">
              <text-field-formatador-de-valor
                v-model="editedItem.pedido_minino_compra"
                :maxDigitos="2"
                :removerValorIrrelevante="true"
                :propsVuetify="{
                  outlined: true,
                  autofocus: true,
                  label: 'Pedido Mínimo de Compra*',
                  prefix: 'R$',
                  errorMessages: pedidoMinimoErrors
                }"
                @input="$v.editedItem.pedido_minino_compra.$touch()"
                @blur="$v.editedItem.pedido_minino_compra.$touch()"
              />
            </v-col>

            <v-col class="pb-0 mb-n3">
              <text-field-formatador-de-valor
                outlined
                v-model="editedItem.tempo_forecast"
                label="Previsão de Gatilho*"
                :removerValorIrrelevante="true"
                :error-messages="tempoForecastErrors"
                @input="$v.editedItem.tempo_forecast.$touch()"
                @blur="$v.editedItem.tempo_forecast.$touch()"
              />
            </v-col>

            <v-col cols="3" class="pb-0 mb-n3">
              <v-select
                v-model="editedItem.ativo"
                :items="ativoDesativado"
                label="Ativo"
                outlined
                item-text="ativo"
                item-value="id"
                :error-messages="ativoErrors"
                @input="$v.editedItem.ativo.$touch()"
                @blur="$v.editedItem.ativo.$touch()"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pb-0 mb-n3">
              <v-select
                v-model="editedItem.ressuprimento_manual"
                :items="ativoDesativado"
                label="Ressuprimento Manual"
                outlined
                item-text="ativo"
                item-value="id"
                :error-messages="ressuprimentoManualErrors"
                @input="$v.editedItem.ressuprimento_manual.$touch()"
                @blur="$v.editedItem.ressuprimento_manual.$touch()"
              />
            </v-col>

            <v-col class="pb-0 mb-n3">
              <text-field-formatador-de-valor
                v-model="editedItem.ressuprimento_qtde_dias"
                :maxDigitos="2"
                :removerValorIrrelevante="true"
                :propsVuetify="{
                  outlined: true,
                  label: 'Ressuprimento Qtde Dias',
                  suffix: 'dias',
                  errorMessages: ressuprimentoQtdeDiasErrors
                }"
                @input="$v.editedItem.ressuprimento_qtde_dias.$touch()"
                @blur="$v.editedItem.ressuprimento_qtde_dias.$touch()"
              />
            </v-col>
          </v-row>

          <v-row>
            <!-- <v-col class="mb-n4">
              <v-select
                v-model="editedItem.calcular_litragem"
                :items="ativo_desativado_litragem"
                label="Calcular Litragem"
                outlined
                item-text="ativo"
                item-value="id"
                :error-messages="calcularLitragemErrors"
                @input="$v.editedItem.calcular_litragem.$touch()"
                @blur="$v.editedItem.calcular_litragem.$touch()"
              />
            </v-col> -->

            <v-col class="mb-n4">
              <v-select
                v-model="editedItem.tipo_litragem"
                :items="tipo_litragem"
                label="Tipo Litragem"
                outlined
                item-text="ativo"
                item-value="id"
                :error-messages="tipoLitragemErrors"
                @input="$v.editedItem.tipo_litragem.$touch()"
                @blur="$v.editedItem.tipo_litragem.$touch()"
              />
            </v-col>
          </v-row>

          <div class="row py-0 mb-2">
            <div class="col pa-0 my-0 ml-1">
              <v-checkbox v-model="editedItem.calcular_litragem" label="Calcular Litragem" />
              <v-checkbox v-model="editedItem.fornecedor_local" label="Fonecedor Local" />
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="mt-n9">
          <v-spacer></v-spacer>
          <v-btn text @click="fecharDialog()">Sair</v-btn>
          <v-btn text @click="save()" color="primary">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FornecedorAPI from "../../../api/fornecedor";
import { required } from "vuelidate/lib/validators";
import TextFieldFormatadorDeValor from "../../utils/TextFieldFormatadorDeValor.vue";

export default {
  components: { TextFieldFormatadorDeValor },
  props: ["dialogEditFornecedor", "item", "multiplos_fornecedores_selecionados"],
  data() {
    return {
      dialog: false,
      multiplos_fornecedores: false,
      editedItem: {
        ressuprimento_manual: "",
        ressuprimento_qtde_dias: 0,
        pedido_minino_compra: 0,
        tempo_forecast: "",
        ativo: "",
        calcular_litragem: "",
        tipo_litragem: '',
        fornecedor_local: false
      },
      ativoDesativado: [
        { id: "S", ativo: "SIM" },
        { id: "N", ativo: "NÃO" },
      ],
      ativo_desativado_litragem: [
        { id: true, ativo: "SIM" },
        { id: false, ativo: "NÃO" },
      ],
      tipo_litragem: [
        { id: "LT", ativo: "LITRO" },
        { id: "GL", ativo: "GALÃO" },
      ],
      formatoPedidoMinimo: {
        currency: null,
        distractionFree: { hideCurrencySymbol: false },
        precision: 2,
        autoDecimalMode: true,
      },
      formatoTempoForecast: {
        currency: null,
        distractionFree: { hideCurrencySymbol: false },
        precision: 0,
        valueAsInteger: true,
      },
    };
  },
  validations: {
    editedItem: {
      pedido_minino_compra: { required },
      tempo_forecast: { required },
      ativo: { required },
      ressuprimento_manual: { required },
      ressuprimento_qtde_dias: { required },
      calcular_litragem: { required },
      tipo_litragem: { required },
    },
  },
  computed: {
    pedidoMinimoErrors() {
      const errors = [];
      if (!this.$v.editedItem.pedido_minino_compra.$dirty) return errors;
      !this.$v.editedItem.pedido_minino_compra.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    tempoForecastErrors() {
      const errors = [];
      if (!this.$v.editedItem.tempo_forecast.$dirty) return errors;
      !this.$v.editedItem.tempo_forecast.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    ativoErrors() {
      const errors = [];
      if (!this.$v.editedItem.ativo.$dirty) return errors;
      !this.$v.editedItem.ativo.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    ressuprimentoManualErrors() {
      const errors = [];
      if (!this.$v.editedItem.ressuprimento_manual.$dirty) return errors;
      !this.$v.editedItem.ressuprimento_manual.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    ressuprimentoQtdeDiasErrors() {
      const errors = [];
      if (!this.$v.editedItem.ressuprimento_qtde_dias.$dirty) return errors;
      !this.$v.editedItem.ressuprimento_qtde_dias.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    calcularLitragemErrors() {
      const errors = [];
      if (!this.$v.editedItem.calcular_litragem.$dirty) return errors;
      !this.$v.editedItem.calcular_litragem.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    tipoLitragemErrors() {
      const errors = [];
      if (!this.$v.editedItem.tipo_litragem.$dirty) return errors;
      !this.$v.editedItem.tipo_litragem.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
  },
  watch: {
    dialogEditFornecedor() {
      this.dialog = this.dialogEditFornecedor;
    },
    item() {
      this.abrirEdicao();
    },
  },
  methods: {
    removerMascara(valor) {
      return parseFloat(
        "".concat(valor).replace(/[.]/g, "").replace(/[,]/g, ".")
      );
    },
    abrirEdicao() {
      this.editedItem = this.item;
    },
    fecharDialog() {
      this.$emit("fecharDialogEditFornecedor");
      this.multiplos_fornecedores = false;
      this.editedItem = {
        pedido_minino_compra: 0,
        tempo_forecast: "",
        ativo: "",
        ressuprimento_manual: "",
        ressuprimento_qtde_dias: 0,
        calcular_litragem: "",
        tipo_litragem: '',
        fornecedor_local: false
      };
      this.$v.$reset();
    },
    save() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        this.editedItem.tempo_forecast = this.removerMascara(this.item.tempo_forecast);

        const params = {
          ...this.editedItem,
          multiplos_fornecedores: this.multiplos_fornecedores,
          fornecedores_selecionados: this.multiplos_fornecedores_selecionados.map(map => map.id)
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          FornecedorAPI.editarParametrosFornecedor(headers, params)
            .then((response) => {
              const { token } = response.data;
              localStorage.setItem("token", token);

              this.$emit("fecharDialogEditFornecedor");
              this.$emit("incializeDialogEditFornecedor");
              this.fecharDialog();
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
  },
};
</script>

<style>
</style>
